import { Avatar, Group, Text } from '@mantine/core';
import classnames from 'classnames';
import { Wrapper } from './Uploader.style';

export type UploaderProps = {
  uploaderAvatar: string;
  uploaderName: string;
  daysAgo: number;
  large?: boolean;
};

export function Uploader(props: UploaderProps) {
  const { large, uploaderAvatar, uploaderName, daysAgo } = props;

  const className = classnames('Uploader-wrapper', {
    large,
  });

  return (
    <Wrapper className={className} data-testid='Uploader-wrapper'>
      <Group gap='sm'>
        <Avatar src={uploaderAvatar} alt={uploaderName} size='md' />
        <div>
          <Text fw={500} size='sm'>
            {uploaderName}
          </Text>
          <Text size='xs' c='dimmed'>
            {daysAgo} days ago
          </Text>
        </div>
      </Group>
    </Wrapper>
  );
}

export default Uploader;
